export const SDK_VERSION = '7.22.0';
